import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-call-modal',
  templateUrl: './call-modal.component.html',
  styleUrls: ['./call-modal.component.css']
})
export class CallModalComponent implements OnInit {
  @Input() callDetails;
  @Output() onCloseModal = new EventEmitter<any>()
  isMinimized = false;
  constructor() { }

  ngOnInit() {
    console.log("Call Modal",this.callDetails);
  }

  closeModal(){
    this.onCloseModal.emit()
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
  }
}
